import styles from "./app.module.scss";
import Home from "./pages/home/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignUp from "./pages/signUp/SignUp";
import Login from "./pages/login/Login";
import Domainsection from "./pages/domainsection/Domainsection";
import MobileAppSection from "./pages/mobileAppSection/MobileAppSection";
import ApplicationSection from "./pages/applicationSection/ApplicationSection";
import PaymentSection from "./pages/paymentSection/PaymentSection";
import CareersPage from "./pages/careersPage/CareersPage";
import BlogPage from "./pages/blogPage/BlogPage";
import Contact from "./components/contact/Contact";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/domain" element={<Domainsection />} />
        <Route path="/mobile" element={<MobileAppSection />} />
        <Route path="/application" element={<ApplicationSection />} />
        <Route path="/payment" element={<PaymentSection />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
